module.exports = __webpack_public_path__ + "img/vk-icon.bc315ff7.svg";